import React, {useState, useEffect } from 'react';
import GreenButton from '../components/buttons/GreenButton';
import BlueButton from '../components/buttons/BlueButton';
// import EdumanNoText from '../components/eduman/EdumanNoText';
// import SpeechBubbles from '../components/textBubbles/SpeechBubble';
import '../helpers/edumanIntersector';
import '../assets/css/pages/landing.css';
import region1 from '../assets/images/icons/regions/R1.svg';
import region3 from '../assets/images/icons/regions/R3.svg';
import region5 from '../assets/images/icons/regions/R5.svg';
import region8 from '../assets/images/icons/regions/R8.svg';
import region14 from '../assets/images/icons/regions/R14.svg';
import region15 from '../assets/images/icons/regions/R15.svg';
import region16 from '../assets/images/icons/regions/R16.svg';
import region17 from '../assets/images/icons/regions/R17.svg';
import region18 from '../assets/images/icons/regions/R18.svg';
import BlueGuy from '../assets/images/Heroes/BlueGuy.svg';
import GreenGuy from '../assets/images/Heroes/GreenGuy.svg';
import PurpleGuy from '../assets/images/Heroes/PurpleGuy.svg';
import YellowGirl from '../assets/images/Heroes/YellowGirl.svg';
import PurpleGirl from '../assets/images/Heroes/PurpleGirl.svg';
import PinkGirl from '../assets/images/Heroes/PinkGirl.svg';
import eduwoman2 from '../assets/images/Heroes/eduwoman-2.svg';
import bubble from '../assets/images/bubble.svg';
import duck from '../assets/images/Duck.svg';
import wow from '../assets/images/Wow.svg';
import pow from '../assets/images/Pow.svg';
import spiral from '../assets/images/spiral.svg';
import cityBackgroundDarker from '../assets/images/cityScapeDarkerBlue.svg';
import cityBackgroundDark from '../assets/images/cityScapeDarkBlue.svg';
// import loginSignupLogo from '../assets/images/login-signup-logo.svg';
import eduheroLogo from '../assets/images/Titles/eduheroLogoWithWords.svg';
// import heroesCityTitle from '../assets/images/heroesCityTitle.svg';
import eduwoman from '../assets/images/Eduwoman.svg';
import edumanAboutUs from '../assets/images/edumanAboutUs.svg';
import loginWords from '../assets/images/log-in-words.svg';
import signupWords from '../assets/images/sign-up-words.svg';
import engagingImage from '../assets/images/Engaging-Image.svg';
import interactiveImage from '../assets/images/Interactive-Image.svg';
import selfPaceImage from '../assets/images/Self-paced-image.svg';
import comicOnboardImage from '../assets/images/comic-onboarding-guide-min.svg';
import comicLevelup from '../assets/images/comic-levelup.svg';
// import comicLevelup from '../assets/images/comic-levelup-min.svg';
// import comicTrackImage from '../assets/images/comic-track-course-min.svg';
import comicTrackImage from '../assets/images/comic-track-course.svg';
import comicCertificatesImage from '../assets/images/comic-earn-certificates-min.svg';
// import comicDevelopImage from '../assets/images/comic-develop-skills.svg';
import comicDevelopImage from '../assets/images/comic-develop-skills-min.svg';
import greenCloud from '../assets/images/green-cloud.svg';
import greenCloudSmall from '../assets/images/green-cloud-small.svg';
import blueBurst from '../assets/images/blue-burst.svg';
import joinUsTodayText from '../assets/images/join-us-today-text.svg';
import edumanRipShirt from '../assets/images/Heroes/join-us-graphic.svg'

import CarouselComp from '../components/carousel/CarouselComp';
import ComicCarousel from '../components/carousel/ComicCarousel';
import { useNavigate } from 'react-router-dom';
import SignUp from '../components/login/SignUp';
import Login from '../components/login/LogIn';


const Landing2 = () => {
    const navigate = useNavigate();
    
    const [loginSelected, setLoginSelected] = useState(false);
    const [signSelected, setSignSelected] = useState(false);
    const [fetchMessage, setFetchMessage] = useState(false);
    const [currentComic, setCurrentComic] = useState(false);

    // comic order does matter, is a stack
    const comicArray2 = [
        <img src={comicOnboardImage} alt="Onboarding guide comic"  />,
        <img src={comicLevelup} alt="Onboarding guide comic"  />,
        <img src={comicCertificatesImage} alt="Onboarding guide comic"  />,
        <img src={comicTrackImage} alt="Onboarding guide comic"  />,
        <img src={comicDevelopImage} alt="Onboarding guide comic"  />,

    ]
    const comicArray = [
        {
            svg: comicOnboardImage, 
            alt: "Onboarding guide comic", 
            title: "Grab the first issue of the series!", 
            info: "Districts that sign up to Eduhero receive instant access to the Eduhero Onboarding Guide. <br/>Dive deep into the inner workings of Eduhero with detailed instructions for districts and campus managers to effectively upload staff, manage rosters, assign courses, and run reports! <br/>Everything you need to get the most out of Eduhero.",
            htmlType: `img`,
            htmlInfo: {
                src: comicOnboardImage,
                className: 'test',
                alt: "Onboarding guide comic", 
            }
        }, 
        {
            svg: comicLevelup, 
            alt: "Levelup comic", 
            title: "Level up & Personalize", 
            info: "Challenge yourself by engaging in interactive courses designed to enhance your skills and earn knowledge points (KP) along the way.<br/>Use these points to unlock a variety of exciting avatars and vibrant backgrounds.<br/>Keep track of your achievements by climbing the leaderboards, sharing milestones with your community on social media, and fostering friendly competition with fellow educators.",
            htmlType: `img`,
            htmlInfo: {
                src: comicLevelup,
                className: "test",
            }
        }, 
        {
            svg: comicCertificatesImage, 
            alt: "Earn certificates comic", 
            title: "Not All Heroes Wear Capes", 
            info: "In the halls, on the playground, and behind the scenes, school staff are the Eduheroes making an extraordinary impact every day.",
            htmlType: `img`,
            htmlInfo: {
                src: comicCertificatesImage,
                className: "test",
            }
        }, 
        {
            svg: comicTrackImage, 
            alt: "Track courses comic", 
            title: "Stay on Track and Organized", 
            info: "Accountability is essential, which is why Eduhero provides administrators the ability to compile reports and document completions.<br/>Our mobile-friendly platform ensures the data you need is at your fingertips.",
            htmlType: `img`,
            htmlInfo: {
                src: comicTrackImage,
                className: "test",
            }
        }, 
        {
            svg: comicDevelopImage, 
            alt: "Develop skills comic", 
            title: "Develop skills anytime, anywhere", 
            info: "Enhance learning by choosing the most effective time and place on our tablet-friendly platform. <br/>Improve efficiency by accessing unlimited online professional development in a variety of subjects.",
            htmlType: `img`,
            htmlInfo: {
                src: comicDevelopImage,
                className: "test",
            }
        }
    ]

    useEffect(() => {

        fetch(`/routes/api/sessions/landingCheck/`,
            {
                method: "POST",
                headers: {
                Accepts: "application/json",
                    "Content-Type": "application/json"
                },
                credentials: "include"
            }
        )
        .then(res => {
            if(res.ok) {
                return res.json();
            }
            throw new Error("Res not ok. Landing check.");
        })
        .then(({type}) => {
            if(type && type === "success") {
                navigate("/client/home")
            }

            if(comicArray) {
                setCurrentComic(comicArray[comicArray.length-1]);
            }
        })
        .catch(err => {
            console.log(err);

            if(comicArray) {
            setCurrentComic(comicArray[comicArray.length-1]);
        }
        })
    }, []);


    return(
        <main className="comicNueFont landingPage">
            {/* Landing Page Center Piece */}
            <section className="flex flexColumn flexAlignCenter landingSection clipTopFlatBottomDownLeft">
                <img src={spiral} alt="Background spiral" className='landingBgSpiral' />
                <img className='eduheroLogo' alt='Eduhero Logo.' src={eduheroLogo} />
                {/* buttons */}
                <div className='buttons'>
                    {/* Login Button */}
                    <div class="buttonWrapper">
                        <GreenButton setTrue={setLoginSelected} setFalseArr={[setSignSelected, setFetchMessage]}>
                            <img src={loginWords} alt='login'></img>
                        </GreenButton>
                    </div>

                    {/* Sign Up Button */}
                    <div class="buttonWrapper">
                        <BlueButton setTrue={setSignSelected} setFalseArr={[setLoginSelected, setFetchMessage]} >
                            <img src={signupWords} alt='sign up'></img>
                        </BlueButton>
                    </div>
                </div>

                <div className='flex flexCenter firstInfoPanel' >
                    <div className='selfPlacedContainer'>
                        <div className='selfPacedWrapper landingImgWrapper'>
                            <img src={selfPaceImage} alt='Self-Paced' className='selfPacedBg' ></img>
                            <div className='selfPlacedBathContainer'>
                                <img src={bubble} alt="bubble" className='bubble1' />
                                <img src={bubble} alt="bubble" className='bubble2' />
                                <img src={bubble} alt="bubble" className='bubble3' />
                                <img src={bubble} alt="bubble" className='bubble4' />
                                <img src={bubble} alt="bubble" className='bubble5' />
                                <img src={duck} alt="Rubber duck" className='duck' />
                            </div>
                        </div>
                        <div className='landingImgText selfPlacedText'>
                            SELF-PACED
                        </div>
                    </div>
                    <div className='interactiveContainer'>
                        <div className='interactiveWrapper landingImgWrapper'>
                            <img src={interactiveImage} alt='Interactive' className='interactiveBg' ></img>
                            <img src={eduwoman} className='eduwomanLanding' alt='Eduwoman' ></img>
                        </div>
                        <div className='landingImgText interactiveText'>
                            INTERACTIVE
                        </div>
                    </div>
                    <div className='engagingContainer'>
                        <div className='engagingWrapper landingImgWrapper'>
                            <img src={engagingImage} alt='Engaging' className='engagingBg' ></img>
                            <div className='engagingHeroWrapper'>
                                <img src={PurpleGuy} alt="Purple Guy" className='purpleGuy' />
                                <img src={PinkGirl} alt="Pink Girl" className='pinkGirl' />
                                <img src={PurpleGirl} alt="PurpleGirl" className='purpleGirl' />
                                <img src={GreenGuy} alt="Green Guy" className='greenGuy' />
                                <img src={YellowGirl} alt="Yellow Girl" className='yellowGirl' />
                                <img src={BlueGuy} alt="Blue Guy" className='blueGuy' />
                            </div>
                        </div>
                        <div className='landingImgText engagingText'>
                            ENGAGING
                        </div>
                    </div>
                </div>

                <div className=' flex landingInfoContainer'>
                    <div className="landingInfoText">
                        Our online e-learning platform delivers professional development credits, anytime, anywhere.
                    </div>
                    <img src={wow} alt="Wow" className='wow' />
                </div>

                {/* <div className="flex flexColumn landingUpperHalf">
                    <div className="flex flexCenter buttonsSignLogin">
                        <div className='landingImageWrapper'>
                            <div className='landingImageContainer'>
                                <img className='heroesBackground' alt='Heroes in cityscape as the background of the page.' src={heroesCityTitle} />
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* <a href="#aboutSectionLanding"><SpeechBubbles>WOULD YOU LIKE<br /> TO LEARN MORE?<br />CLICK HERE!</SpeechBubbles></a>
                <EdumanNoText /> */}
                {/* Learn More Link */}
            </section>

            {/* About Us Section */}
            <section className="aboutSectionLanding clipTopDownLeftBottomDownLeft">
                <div className="flex flexCenter flexColumn aboutContentContainer">
                    <div className='videoContainer'>
                        <h2 id="aboutSectionLanding">WHAT IS EDUHERO?</h2>
                        <iframe className="video" width="560" height="315" src="https://www.youtube.com/embed/ZnOkjT2X31A?si=FF87Ng4aa7KcZJ75" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                    <img alt='Eduman talking about what we offer.' className='edumanAboutUs' src={edumanAboutUs} defer />
                    {/* <EdumanNoText /> */}

                </div>
            </section>

            {/* What We Do/Content Section */}
            <section className="whatWeDo clipTopDownLeftBottomDownRight">
                    <h2 className="textAlignRight">WHAT DOES EDUHERO OFFER?</h2>
                    <div className='grid-container-landing1 flex flexCenter flexColumn'>
                        <img alt='City Background' src={cityBackgroundDark} className='whatWeDoCityDark' />
                        <img alt='City Background' src={cityBackgroundDarker} className='whatWeDoCityDarker' />
                        <div className='grid-item0 flex flexCenter'>
                            <div className='comics'>
                                <img src={greenCloudSmall} alt="Small green cloud" />                                
                                <ComicCarousel setCurrentSlide={setCurrentComic} imageArr={comicArray} timer={19000} />
                            </div>
                            <div className='eduwomanWrapper'>
                                <img src={eduwoman2} alt="Eduwoman Pose 2" className='eduwoman' />
                                <img src={greenCloud} alt="Green cloud" className='greenCloud' />
                            </div>
                        </div>
                        <div className='nonComicContent flex flexCenter'>
                            <div className='grid-item1 flex flexCenter'>
                                <div>
                                    <h3 className='textAlignCenter'>{currentComic && currentComic.title}</h3>
                                    {currentComic && currentComic.info.split("<br/>").map(p => (
                                        <p>{p}</p>
                                    ))}
                                </div>
                            </div>
                            <div className='grid-item2 flex flexCenter'>
                                {currentComic && <img src={currentComic.svg} alt={currentComic.alt} />}
                            </div>
                        </div>
                    </div>
            </section>

            {/* Buy Us Section */}
            <section className="flex flexCenter flexColumn whoSuppportsUs clipTopDownRightBottomDownLeft">
                <div className='flex flexCenter textAlignLeft whoSupportsUs-info'>
                    <div>
                        <img src={pow} alt="Pow" />
                    </div>
                    <p> Eduhero has joined forces with Regional Education Service Centers (ESCs). These partnerships reflect our commitment to working jointly with educational leaders across the state of Texas. </p>
                </div>
                <div className='flex flexCenter flexColumn whoSupportsUs-container'>
                    <img src={blueBurst} alt="Blue burst effect" />
                    <h2>ESC PARTNERSHIPS</h2>
                    <div className='grid-container-landing2'>
                        <img alt="ESC Region 1 Logo" className='grid-reg1' src={region1} />
                        <img alt="ESC Region 3 Logo" className='grid-reg3' src={region3} />
                        <img alt="ESC Region 5 Logo" className='grid-reg5' src={region5} />
                        <img alt="ESC Region 8 Logo" className='grid-reg8' src={region8} />
                        <img alt="ESC Region 14 Logo" className='grid-reg14' src={region14} />
                        <img alt="ESC Region 15 Logo" className='grid-reg15' src={region15} />
                        <img alt="ESC Region 16 Logo" className='grid-reg16' src={region16} />
                        <img alt="ESC Region 17 Logo" className='grid-reg17' src={region17} />
                        <img alt="ESC Region 18 Logo" className='grid-reg18' src={region18} />
                    </div>
                </div>
            </section>
            <section className=' flex flexCenter clipTopDownLeftBottomFlat buyUs'>
                <div>
                    <img src={edumanRipShirt} alt="Eduman ripping shirt off" />
                </div>
                <div className='buyUs-container flex flexCenter flexColumn'>
                    <img src={joinUsTodayText} alt="Join us today" />

                    {/* sign up button bottom of page */}
                    <BlueButton setTrue={setSignSelected} setFalseArr={[setLoginSelected]} >
                        <img src={signupWords} alt="Sign up words" />
                    </BlueButton>
                </div>
            </section>
            
            {/* Login Modal */}
            <Login
                controllerState={loginSelected}
                setControllerState={setLoginSelected}
                fetchMessage={fetchMessage}
                setFetchMessage={setFetchMessage}
            />

            {/* Sign Up Modal */}
            <SignUp 
                controllerState={signSelected} 
                setControllerState={setSignSelected} 
                setLoginSelected={setLoginSelected}
                fetchMessage={fetchMessage}
                setFetchMessage={setFetchMessage}
            />
        </main>
    );
};

export default Landing2;